import request from "@/utils/request";

export default {
    query(param){
        return request({
            url:"/five-bit-code",
            method:"get",
            params:param
        })
    },
    getDetail(fiveBitCode){
        return request({
            url:`/five-bit-code/${fiveBitCode}`,
            method:"get"
        })
    }
}
